type TeamLearnersByEvaluationId = Record<
  string,
  { latestEvaluation?: { organisation?: { id: string } } }
>;

export const getEvaluationSearches = (
  organisationIds: string[],
  evaluationIds: string[],
  teamLearners?: TeamLearnersByEvaluationId,
) =>
  organisationIds.map((organisationId) => ({
    organisationId,
    evaluationIds: teamLearners
      ? evaluationIds.filter(
          (evaluationId) =>
            teamLearners[evaluationId]?.latestEvaluation?.organisation?.id ===
            organisationId,
        )
      : evaluationIds,
  }));
